import React, { useEffect } from "react";
import type { GetStaticProps, NextPage } from "next";
// import SecureRoute from "../lib/secureRoute";
// import { Groups } from "../components/group";
import { getTranslations } from "../lib/translations";
import { useRouter } from "next/router";
import { Center } from "../components/basic";
import Loading from "./loading";

const GroupsPage: NextPage = () => {
	const router = useRouter();
	useEffect(() => {
		router.push("/");
	}, [router]);
	// return (
	// 	<SecureRoute>
	// 		<Groups />
	// 	</SecureRoute>
	// );
	return (
		<Center>
			<Loading />
		</Center>
	);
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
	const messages = await getTranslations(locale, ["groups", "common"]);
	return {
		props: {
			messages,
		},
	};
};

export default GroupsPage;
